import MainNav from '../components/MainNav';
import MainFooter from '../components/MainFooter';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const NewsletterFeb2026Page = () => {
    const newsletter = {
        month: 'February 2026',
        volume: 'Volume 1, Issue 11',
        title: 'R&R News',
        tagline: 'Each one. Reach one. Teach one.',
        coverImage: 'https://customer-assets.emergentagent.com/job_member-hub-104/artifacts/1kj4oind_1.png',
        founderImage: 'https://customer-assets.emergentagent.com/job_member-hub-104/artifacts/g3i05c7p_Founder.jpg',
        foundersDesk: `Brothers,

As we close out Black History Month, I want to take a moment to honor the legacy of many great men who came before us. The Recovery Room continues to grow into a powerful space rooted in reflection, healing, accountability, and purpose. Your presence, honesty, and commitment are what make this community more than a gathering. I'm reminded of how much of a force we've become grounded in intention and impact.

This month, I could not physically be present at the gathering, but I wanted to take the time to publicly thank Anthony Carter for stepping up in my absence. Every act of support moves us forward.

We are also continuing our "Highlight A Brother" recognition. Each month, you are invited to nominate a brother whose leadership, growth, or service deserves acknowledgment. Nominations are due by the 5th of each month, giving us a consistent opportunity to celebrate one another intentionally.

Black History Month reminds us that legacy is built through action. Let's continue doing the work together.

Brotherhood. Accountability. Elevation.

With appreciation,

Herman I. Pryor, Jr., Ed.D.
Founder | Recovery Room`,
        sections: [
            {
                title: "February 2026 - R&R Gathering Recap",
                image: 'https://customer-assets.emergentagent.com/job_member-hub-104/artifacts/hj5y0wne_Recap.png',
                content: `Our February 2026 Recovery Room Saturdays gathering set a powerful tone for Black History Month. The energy in the room was deeply connected and affirming—a reminder that when we come together, we are not only honoring the legacy of those who came before us, but actively creating our own Black history through our daily efforts, discipline, and brotherhood.

This month reaffirmed what we know to be true: when we gather with intention, we create space for healing, elevation, and collective strength. Special shout out to Anthony Carter (pictured centered) who coordinated and facilitated this month's gathering.

March 2026

Join us on Saturday, March 7, 2026, as we spring into more context, dialogue, and community in 2026. We look forward to reconnecting with you!

📅 Saturday, March 7, 2026
🕠 5:30pm - 8pm

Please RSVP below, and feel free to invite another brother to join you. Together, let's continue strengthening our community, one connection at a time.`
            },
            {
                title: "Follow Recovery Room on Instagram and Facebook!",
                content: `We've officially expanded our community presence, and we'd love for you to stay connected with us in real time!

Our Recovery Room Instagram page is live. We've created a space to share inspiration, upcoming events, wellness insights, and moments from our gatherings that remind us of the power of brotherhood.

Follow us on Instagram @recoveredbrother and join the conversation as we continue to grow, uplift, and connect beyond our in-person sessions.

See you there, brothers!`
            },
            {
                title: "COMMUNITY EVENTS",
                subtitle: "Black House Collection Community Mixer",
                image: 'https://customer-assets.emergentagent.com/job_member-hub-104/artifacts/kfmvoyr7_Mixer.png',
                content: `Brothers,

You are cordially invited to get to know the Black House Collection (@blackhousecollection) brand at our upcoming Community Mixer this week! ✨

If you're a creative, content creator, entrepreneur, podcaster, chef, photographer, or someone on the verge of stepping boldly into your own lane—and you're looking for office, meeting, or co-working space to work, build, or host workshops—this mixer is for you. 🫵🏾

Join us this Thursday at our flagship location, The Metropolitan by Black House Collection, conveniently located near the H Street Corridor in NE DC (the space where we currently host Recovery Room Saturdays). Connect with new and current members of the BHC community and learn more about our offerings, including memberships and event space opportunities.

Enjoy BHC trivia, special giveaways, and more! Don't miss the opportunity to find your tribe alongside fellow creatives, leaders, and builders from across the DMV.

This isn't just a mixer. It's a room full of vision, connection, and momentum.

Let's honor where we've come from — and move intentionally toward where we're going.

📍 The Metropolitan by Black House Collection
🗓 February 26 | 5:30 PM
🔗 RSVP are on a first come first serve basis as space is limited.

🚨 Complimentary tickets listed on the RSVP page are reserved for current members only. 🚨

We can't wait to meet you!

Thank you in advance for your support and continued encouragement.

Herman I. Pryor Jr., Ed.D.
Founder | CEO
@blackhousecollection`
            },
            {
                title: "CAREER OPPORTUNITIES",
                subtitle: "Executive Director",
                image: 'https://customer-assets.emergentagent.com/job_member-hub-104/artifacts/98a4e6vs_unnamed%20%286%29.jpg',
                content: `Sojourner Truth Montessori Public Charter School

Washington, DC

Salary: $150,000-$195,000 per year

In-Person/Onsite`
            },
            {
                title: "BLACK MEN'S MEDITATION",
                subtitle: "168 Black Men Meditated Together",
                image: 'https://customer-assets.emergentagent.com/job_member-hub-104/artifacts/zu9hhi5f_unnamed%20%282%29.png',
                content: `Black men from around the world came together in a powerful virtual meditation session, creating space for collective healing, mindfulness, and brotherhood. This growing movement reminds us that taking time for stillness and reflection is not just self-care—it's an act of resistance and restoration.

Join the movement and prioritize your mental wellness.`
            },
            {
                title: "COMMUNITY RESOURCES",
                subtitle: "Reading Materials",
                image: 'https://customer-assets.emergentagent.com/job_member-hub-104/artifacts/t1xj9r0y_unnamed%20%285%29.jpg',
                content: `Explore resources to support your journey of growth, healing, and self-development.`
            }
        ]
    };

    return (
        <div className="min-h-screen bg-[#3D4435]">
            <MainNav />
            
            <main className="pt-32 pb-24 px-6">
                <div className="max-w-4xl mx-auto">
                    {/* Back Button */}
                    <Link to="/community/newsletter" className="inline-flex items-center gap-2 text-[#C9A227] hover:text-[#E8D48A] mb-8 transition-colors">
                        <ArrowLeft className="w-4 h-4" />
                        Back to Newsletters
                    </Link>

                    {/* Newsletter Content */}
                    <Card className="bg-[#4A5240] border-[#C9A227]/50 overflow-hidden">
                        <div className="h-2 bg-gradient-to-r from-[#C9A227] to-[#E8D48A]" />
                        <CardContent className="p-8">
                            {/* Header */}
                            <div className="text-center mb-8 pb-8 border-b border-[#5A6350]">
                                {/* Cover Image */}
                                {newsletter.coverImage && (
                                    <img 
                                        src={newsletter.coverImage}
                                        alt="Recovery Room Newsletter"
                                        className="w-full max-w-lg mx-auto rounded-xl mb-6"
                                    />
                                )}
                                <p className="text-[#C9A227] text-sm uppercase tracking-[0.2em] font-medium mb-2">
                                    {newsletter.month} • {newsletter.volume}
                                </p>
                                <h1 className="text-4xl font-bold text-white font-['Playfair_Display'] mb-3">
                                    {newsletter.title}
                                </h1>
                                <p className="text-[#A0A0A0] italic text-lg">
                                    Elevating safe spaces for Black men
                                </p>
                                <p className="text-[#C9A227] font-medium mt-4 text-xl">
                                    "{newsletter.tagline}"
                                </p>
                            </div>

                            {/* From the Founder's Desk */}
                            <div className="pb-8 mb-8 border-b border-[#5A6350]">
                                <h2 className="text-2xl font-bold text-[#C9A227] font-['Playfair_Display'] mb-6">
                                    From the Founder's Desk: Happy Black History Month!
                                </h2>
                                <div className="flex flex-col md:flex-row gap-6">
                                    <div className="md:w-1/3 flex-shrink-0">
                                        <img 
                                            src={newsletter.founderImage} 
                                            alt="Dr. Herman I. Pryor Jr., Ed.D."
                                            className="w-full max-w-[250px] mx-auto rounded-xl object-cover"
                                        />
                                    </div>
                                    <div className="md:w-2/3 text-[#A0A0A0] whitespace-pre-line leading-relaxed">
                                        {newsletter.foundersDesk}
                                    </div>
                                </div>
                            </div>

                            {/* Other Newsletter Sections */}
                            <div className="space-y-8">
                                {newsletter.sections.map((section, idx) => (
                                    <div key={idx} className="pb-8 mb-8 border-b border-[#5A6350] last:border-0 last:mb-0 last:pb-0">
                                        <h2 className="text-2xl font-bold text-[#C9A227] font-['Playfair_Display'] mb-2">
                                            {section.title}
                                        </h2>
                                        {section.subtitle && (
                                            <p className="text-white text-xl font-semibold mb-4">{section.subtitle}</p>
                                        )}
                                        {section.image && (
                                            <img 
                                                src={section.image} 
                                                alt={section.subtitle || section.title}
                                                className="w-full max-w-2xl mx-auto rounded-xl mb-6"
                                            />
                                        )}
                                        <div className="text-[#A0A0A0] whitespace-pre-line leading-relaxed">
                                            {section.content}
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Footer */}
                            <div className="text-center mt-8 pt-8 border-t border-[#5A6350]">
                                <Link to="/community/newsletter">
                                    <Button className="bg-[#C9A227] hover:bg-[#B8922A] text-[#3D4435] font-semibold px-8">
                                        Back to All Newsletters
                                    </Button>
                                </Link>
                            </div>
                        </CardContent>
                    </Card>
                </div>
            </main>

            <MainFooter />
        </div>
    );
};

export default NewsletterFeb2026Page;
